import React from 'react';
import { useSelector } from 'react-redux';
import { useDrawerNavigation } from '../context/DrawerNavigationContext';
import { useCurrentPath } from '../context/CurrentPathContext';
import NavItem from './NavItem';
import {
	getNavItemKey,
	resolveDirectNavActiveSectionId
} from '../utils/navItemUtils';

/**
 * NavItemList — renders the top-level navigation item list.
 * Reads items from Redux navData slice and navigation state from context.
 * No props required — all state is sourced from context/Redux.
 *
 * Computes resolvedActiveSectionId once at this level so the "exactly one
 * path-match" fallback (direct navigation without _ddc_nav_drawer) can be
 * applied consistently across all items rather than independently per-item.
 */
const NavItemList = () => {
	const items = useSelector((state) => state.navData?.items ?? []);
	const { onSubmenuOpen } = useDrawerNavigation();
	const currentPath = useCurrentPath();

	// When the page URL has no _ddc_nav_drawer param, fall back to path-only
	// matching. If exactly one top-level section has a descendant whose path
	// matches, that section wins. If zero or multiple match, nothing wins.
	const resolvedActiveSectionId = resolveDirectNavActiveSectionId(
		items,
		currentPath
	);

	if (!items || items.length === 0) {
		return null;
	}

	return (
		<ul
			className="ws-nav-drawer__nav-list list-unstyled m-0 overflow-auto flex-column align-items-start align-self-stretch"
			data-testid="nav-item-list"
		>
			{items.map((item, index) => (
				<NavItem
					key={getNavItemKey(item, index)}
					item={item}
					onSubmenuOpen={onSubmenuOpen}
					resolvedActiveSectionId={resolvedActiveSectionId}
				/>
			))}
		</ul>
	);
};

export default NavItemList;
